// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__G58Go","spinnerWrapper":"Loader_spinnerWrapper__eNiax","loader":"Loader_loader__bo-o-","l5":"Loader_l5__lS9yt"};